var map = {
	"./center-justify.png": 46439,
	"./left-justify.png": 63567,
	"./new-window-icon.png": 2107,
	"./print-icon.png": 72500,
	"./print-icon.svg": 37080,
	"./share-icon.png": 18797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24719;